<nav id="menu1" [class]="menu1Class" class="nav nav-visible" *ngIf="!itsMobile">
    <ul>
        <span id="menu1Bar" [class]="menu1BarClass" class="bar"></span>
        <li id="menu1Item1" [ngClass]="{'active-two': contrast}" class="btn-v" (click)="menuClick('menu1', 'menu1Item1')">What if you could shop <br> and redeem as you wish?</li>
        <li id="menu1Item2" [ngClass]="{'active-two': contrast}" class="btn-v" (click)="menuClick('menu1', 'menu1Item2')">Shop and <br> redeem</li>
        <li id="menu1Item3" [ngClass]="{'active-two': contrast}" class="btn-v" (click)="menuClick('menu1', 'menu1Item3')">Voyage Connected <br> World</li>
        <li id="menu1Item4" [ngClass]="{'not-border': contrast}" class="btn-v" (click)="menuClick('menu1', 'menu1Item4')">What if you could switch <br> your rewards to crypto?</li>
        <li id="menu1Item5" class="btn-v">
            <span id="btn-e" (click)="menuClick('menu1', 'menu1Item5')">It's time to embrace <br> the new gig economy!</span>
            <ul>
                <li id="menu1Item5_1" class=" btn-v" (click)="menuClick('menu1', 'menu1Item5_1')">Pay as you wish. <br> Get paid as you please.</li>
                <li id="menu1Item5_2" class=" btn-v" (click)="menuClick('menu1', 'menu1Item5_2')">One wallet for all payments. <br> One solution for all needs.</li>
                <li id="menu1Item5_3" class=" btn-v" (click)="menuClick('menu1', 'menu1Item5_3')">Send your miles. <br> Share the love.</li>
                <li id="menu1Item5_4" class=" btn-v" (click)="menuClick('menu1', 'menu1Item5_4')">Check your balance <br> anytime.</li>
            </ul>
        </li>
        <li id="menu1Item6" [ngClass]="{'not-border': contrast}" class="btn-v" (click)="menuClick('menu1', 'menu1Item6')">Tap more, <br> touch less</li>
        <li id="menu1Item7" [ngClass]="{'not-border': contrast}" class="btn-v" (click)="menuClick('menu1', 'menu1Item7')">Drag and drop. <br> Mix and match.</li>
    </ul>
</nav>
<nav id="menu2" [class]="menu2Class" class="nav2 nav-visible" *ngIf="!itsMobile">
    <img src="./assets/img/cryptmi/miles-logo.svg" alt="gennius">
    <ul>
        <span id="menu2Bar" [class]="menu2BarClass"  class="bar"></span>
        <li id="menu2Item1" class=" btn-v" (click)="menuClick('menu2', 'menu2Item1')">Everyday <br> spend</li>
        <li id="menu2Item2" class=" btn-v" (click)="menuClick('menu2', 'menu2Item2')">Millions of travel <br> options</li>
        <li id="menu2Item3" class=" btn-v" (click)="menuClick('menu2', 'menu2Item3')">Unparalleled <br> travel protection</li>
        <li id="menu2Item4" class=" btn-v" (click)="menuClick('menu2', 'menu2Item4')">Earn more <br> rewards</li>
        <li id="menu2Item5" class=" btn-v" (click)="menuClick('menu2', 'menu2Item5')">Miles <br> management</li>
        <li id="menu2Item6" class=" btn-v" (click)="menuClick('menu2', 'menu2Item6')">Conversational <br> banking</li>
        <li id="menu2Item7" class=" btn-v" (click)="menuClick('menu2', 'menu2Item7')">Split <br> payments</li>
        <li id="menu2Item8" class=" btn-v" (click)="menuClick('menu2', 'menu2Item8')">Pay and <br> get paid</li>
        <li id="menu2Item9" class=" btn-v" (click)="menuClick('menu2', 'menu2Item9')">Buy now, <br> pay later</li>
    </ul>
</nav>
<div [class]="videoClass" class="video-fixed video-visible" *ngIf="!itsMobile">
    <div class="phone">
        <div class="content">
            <video id="videoGeneral" loop autoplay muted playsinline [src]="videoSrc" onloadedmetadata="this.muted = true">
            </video>
        </div>
    </div>
</div>
<section class="snap">
    <section class="scrolling">
        <section id="item-0-section" class="gennius--intro">
            <div class="container gennius">
                <h3 id="item-0">The ultimate loyalty platform banks and merchants were claiming for</h3>
                <span>Welcome to the latest evolution of loyalty payments —an end-to-end solution that achieves <b>more freedom to cardholders and less hassle for banks.</b></span>
                <img class="gennius__img gennius__img--intro" src="./assets/img/gennius/solutions-phones-2.png" alt="gennius">
            </div>
        </section>
        <section id="item-1-section" class="gennius--loyalty">
            <div class="container gennius">
                <img class="gennius__img gennius__img--loyalty" src="./assets/img/gennius/logo-meetmiles.png" alt="gennius">
                <h1  id="item-1" class="text-gradient">The loyalty solution</h1>
                <span class="gennius__subtittle">that's transforming business models</span>
                <div class="gennius__bloque">
                    <div class="gennius__left gennius__left--loyalty">
                        <p><strong>A Super App blending all digital payment solutions into one powerful platform</strong>, miles is the most comprehensive program that provides a single place to pay and get paid, collect, redeem and transfer built-in rewards.</p>
                    </div>
                    <div class="gennius__right gennius__right--loyalty">
                        <ul>
                            <li>
                                <span class="bullet"></span>
                                <p>B2B smart payments platform</p>
                            </li>
                            <li>
                                <span class="bullet"></span>
                                <p>Delivers superior user experiences</p>
                            </li>
                            <li>
                                <span class="bullet"></span>
                                <p>Enhances Loyalty Effect</p>
                            </li>
                            <li>
                                <span class="bullet"></span>
                                <p>Lowers retention costs</p>
                            </li>
                            <li>
                                <span class="bullet"></span>
                                <p>Increases user retention & spending</p>
                            </li>
                            <li>
                                <span class="bullet"></span>
                                <p>Accelerates digital transformation</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    </section>
    <section class="main">
        <section id="item-2-section" class="section parallax1">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>
            <div class="content-text">
                <img src="./assets/img/cryptmi/miles-logo.svg" alt="">
                <h2 id="item-2">features and capabilities</h2>
            </div>
        </section>
        <section id="item-3-section" class="section parallax2" >
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target0">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <h4>What if you could <br> shop and redeem <br> as you wish?</h4>
                                <p><strong>Now you can!</strong> Split your <br> payment to combine crypto, <br> rewards programs, debit/credit <br> cards, and pay in installments.</p>
                            </div>
                            <div id="item-3" class="gennius__right gennius__right--loyalty">
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video autoplay="" id="item-3-video" loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>
        </section>
        <section id="item-4-section" class="section parallax3">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target1">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <h4>Shop and redeem <br> in app, in store or <br> contactless at <br> 100M+ merchants <br> worldwide</h4>
                                <p>Get unlimited access to <br> the <strong>connected world</strong> of <br> banks, airlines, hotels and <br> merchants everywhere.</p>
                                <p>Shop directly at preferred <br> merchants.</p>
                            </div>
                            <div id="item-4" class="gennius__right gennius__right--loyalty">
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video autoplay="" id="item-4-video" loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>
        </section>
        <section id="item-5-section" class="section parallax4">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="content-text target2">
                        <h2 id="item-5" class="text-gradient">Voyage Connected World</h2>
                        <p>Choose from millions of travel deals with preferred rates, stellar benefits and insurance.</p>
                    </div>
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>
        </section>
        <section id="item-6-section" class="section parallax5">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius">
                        <div class="image-voyage">
                            <div class="content-text">
                                <div class="gennius__bloque">
                                    <div class="gennius__left gennius__left--loyalty">
                                        <span id="item-6" class="title">upperMiles: it's <br> leveraged miles</span>
                                        <p><strong>Earn up to 5X rewards</strong> with no limits <br> or expiration dates when spending <br> and redeeming miles.</p>
                                    </div>
                                    <div class="gennius__right gennius__right--loyalty" *ngIf="!itsMobile">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>
        </section>
        <section id="item-7-section" class="section parallax6">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius">
                        <div class="image-voyage">
                            <div class="content-text">
                                <div class="gennius__bloque">
                                    <div class="gennius__left gennius__left--loyalty">
                                        <span id="item-7" class="title">International purchase <br> protection</span>
                                        <p><strong>Our international purchase <br> protection</strong> program grants you instant <br> compensations in case of theft, <br> accidental loss or damaged goods.</p>
                                    </div>
                                    <div class="gennius__right gennius__right--loyalty" *ngIf="!itsMobile"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>
        </section>
        <section id="item-8-section" class="section parallax7">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius">
                        <div class="image-voyage target4_1">
                            <div class="content-text">
                                <div class="gennius__bloque">
                                    <div class="gennius__left gennius__left--loyalty">
                                        <owl-carousel [options]="SlideOptions" [carouselClasses]="['owl-theme', 'sliding']">
                                            <div class="item">
                                                <span class="title">Travel the flex way and with <br> total peace of mind.</span>
                                                <p>Get exclusive travel benefits included <br> with your booking: </p>
                                                <span class="benefit">
                                                    <img src="./assets/img/gennius/icon-flex.svg" alt="">
                                                    Travel flex, with 100% changeable <br> reservations.
                                                </span>
                                            </div>
                                            <div class="item">
                                                <span class="title">Travel the flex way and with <br> total peace of mind.</span>
                                                <span class="benefit">
                                                    <img src="./assets/img/gennius/icon-book.svg" alt="">
                                                    Book flights with no seat <br> restrictions or blackout dates.
                                                </span>
                                                <span class="benefit">
                                                    <img src="./assets/img/gennius/icon-delay.svg" alt="">
                                                    Get instant funds for travel <br> mishaps like flight delays, lost or <br> delayed baggage, and a lot more.
                                                </span>
                                            </div>
                                            <div class="item">
                                                <span class="title">Travel the flex way and with <br> total peace of mind.</span>
                                                <span class="benefit">
                                                    <img src="./assets/img/gennius/icon-protection.svg" alt="">
                                                    International medical assistance <br> and COVID-19 protection.
                                                </span>
                                            </div>
                                        </owl-carousel>
                                    </div>
                                    <div id="item-8" class="gennius__right gennius__right--loyalty">
                                        <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                            <div class="content">
                                                <video autoplay="" id="item-8-video" loop muted playsinline onloadedmetadata="this.muted = true">
                                                </video>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>
        </section>
        <section id="item-9-section" class="section parallax8 item8-A">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target3">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <h4>What if you could <br> switch your rewards <br> to crypto?</h4>
                                <p>Convert your rewards to crypto, <br>or switch to cryptos post-transaction. <strong>Earn and redeem in 250+ cryptocurrencies.</strong></p>
                                <img class="element" src="./assets/img/gennius/crypto-coins.webp" alt="">
                            </div>
                            <div id="item-9" class="gennius__right gennius__right--loyalty">
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video autoplay="" id="item-9-video" loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>

        </section>
        <section id="item-10-section" class="section parallax8 item8-B">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <h4>Ready to dip your <br> toe into NFTs?</h4>
                                <p>Buy NFTs within the <strong>cryptMi app</strong> <br> from Opensea, Coinbase or any <br> NFT marketplace.</p>
                                <img class="element" src="./assets/img/gennius/nfts.webp" alt="">
                            </div>
                            <div id="item-10" class="gennius__right gennius__right--loyalty">
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video autoplay="" id="item-10-video" loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>

        </section>
        <section id="item-11-section" class="section parallax8 item8-C">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <h4 class="target5_1">The metaverse is <br> yours, too!</h4>
                                <p>Search, find and buy lands, <br> avatars or anything in the <br> metaverse.</p>
                                <img class="element" src="./assets/img/gennius/metaverse.webp" alt="">
                            </div>
                            <div id="item-11" class="gennius__right gennius__right--loyalty">
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video autoplay="" id="item-11-video" loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>

        </section>
        <section id="item-12-section" class="section parallax9">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="content-text target4">
                        <h2 id="item-12" class="target6">It's time to embrace <br> the new gig economy!</h2>
                    </div>
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>
        </section>
        <section id="item-13-section" class="section parallax20">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target5">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <h4>Pay as you wish. <br> Get paid as you <br> please.</h4>
                                <p><strong>Instantly pay and get paid</strong>, <br> combining currencies and <br> rewards. Always instantly, <br> always rewarded.</p>
                            </div>
                            <div id="item-13" class="gennius__right gennius__right--loyalty">
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video autoplay="" id="item-13-video" loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>

        </section>
        <section id="item-14-section" class="section parallax21">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <h4>One wallet for <br> all payments. <br> One solution <br> for all needs.</h4>
                                <p>Instant payouts and <br> disbursements.</p>
                            </div>
                            <div id="item-14" class="gennius__right gennius__right--loyalty">
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video autoplay="" id="item-14-video" loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>
        </section>
        <section id="item-15-section" class="section parallax22">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target7">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <h4 class="target9">Send your miles. <br> Share the love.</h4>
                                <p><strong>Transfer miles</strong> to friends and <br> family. Anytime, anywhere.</p>
                            </div>
                            <div id="item-15" class="gennius__right gennius__right--loyalty">
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video autoplay="" id="item-15-video" loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>

        </section>
        <section id="item-16-section" class="section parallax23">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target8">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <h4 class="target10">Check your <br> balance anytime.</h4>
                                <p>Track your transaction history at <br> any moment.</p>
                            </div>
                            <div id="item-16" class="gennius__right gennius__right--loyalty">
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video autoplay="" id="item-16-video" loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>
        </section>
        <section id="item-17-section" class="section parallax24">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target9">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <h4 class="target11">Tap more, <br> touch less</h4>
                                <p><strong>Check out via contactless at physical <br> stores around the world</strong>. Pay as you <br> go when boarding the bus or train, <br> touchlessly.</p>
                            </div>
                            <div id="item-17" class="gennius__right gennius__right--loyalty">
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video autoplay="" id="item-17-video" loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>
        </section>
        <section id="item-18-section" class="section parallax25 section--last">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target10">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <h4 class="target12">Drag and <br> drop. Mix and <br> match.</h4>
                                <p><strong>Combine all your favorite cards <br> upon checkout</strong>. Just drag and drop <br> them to split your payment as you <br> wish.</p>
                            </div>
                            <div id="item-18" class="gennius__right gennius__right--loyalty">
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video autoplay="" id="item-18-video" loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>
        </section>
    </section>
    <section class="scrolling">
        <section id="item-19-section" class="gennius--issuers">
            <div class="container">
                <img class="gennius__img gennius__img--loyalty" src="./assets/img/gennius/logo-whymiles.png" alt="gennius">
                <h1 id="item-19" class="text-gradient">for issuers</h1>
                <span class="subtittle">Our turnkey, white-label super app offers partners the power to increase customer loyalty and retention.</span>
                <div class="image" speed="faster" >
                    <div id="scene" class="container-image">
                        <img class="main-image"  src="assets/img/gennius/phone-issuers.webp" alt="gennius">
                    </div>
                    <div class="bloque-icons">
                        <div class="item one">
                            <img class="bl-image" src="assets/img/gennius/issuers-icon-revenue.png" alt="gennius">
                            <div class="bl-text">
                                <span class="text-gradient">Revenue sharing</span>
                                <p>Our solutions enable profits with limited investment and incremental volume.</p>
                            </div>
                        </div>
                        <div class="item two">
                        <img class="bl-image" src="assets/img/gennius/issuers-icon-accelerated.png" alt="gennius">
                        <div class="bl-text">
                            <span class="text-gradient">Accelerated time-to-market</span>
                            <p>3-week implementation time at no cost. No need to hire or train resources for customer service.</p>
                        </div>
                        </div>
                        <div class="item three">
                        <img class="bl-image" src="assets/img/gennius/issuers-icon-digital.png" alt="gennius">
                        <div class="bl-text">
                            <span class="text-gradient">Digital engagement</span>
                            <p>Ominichannel marketing across channels and segments, with e-commerce lifecycle management.</p>
                        </div>
                        </div>
                        <div class="item four">
                        <img class="bl-image" src="assets/img/gennius/issuers-icon-brand.png" alt="gennius">
                        <div class="bl-text">
                            <span class="text-gradient">Brand-agnostic solutions</span>
                            <p>White-label customized web/app experience with the brand's look and feel.</p>
                        </div>
                        </div>

                        <div class="item five" >
                            <img class="bl-image" src="assets/img/gennius/issuers-icon-security.png" alt="gennius">

                            <div class="bl-text">
                                <span class="text-gradient">Security and privacy</span>
                                <p>Top-notch technology that serves your customers’ safety and security.</p>
                            </div>
                        </div>
                        <div class="item six">
                            <img class="bl-image" src="assets/img/gennius/issuers-icon-conversational.png" alt="gennius">

                            <div class="bl-text">
                                <span class="text-gradient">Conversational banking</span>
                                <p>alle, our smart agent chatbot, provides 24/7 customer support from the app, via WhatsApp, iMessage, Facebook Messenger or Instagram.</p>
                            </div>
                        </div>
                        <div class="item seven">
                            <img class="bl-image" src="assets/img/gennius/issuers-icon-cost.png" alt="gennius">

                            <div class="bl-text">
                                <span class="text-gradient">Cost efficiency</span>
                                <p>Plug & play solutions that don't require the issuer to spend in technological development costs.</p>
                            </div>
                        </div>
                        <div class="item eight">
                            <img class="bl-image" src="assets/img/gennius/issuers-icon-back.png" alt="gennius">

                            <div class="bl-text">
                                <span class="text-gradient">Back office</span>
                                <p>End-to-end and administrative digital portal for partner operational management.</p>
                            </div>
                        </div>
                        <div class="item itembloque"></div>
                    </div>

                </div>
            </div>
        </section>
    </section>
    <section class="main">
        <section id="item-20-section" class="section parallax10">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>
            <div class="content-text">
                <img id="item-20" class="gennius__img gennius__img--loyalty" src="./assets/img/gennius/logo-whymiles-blanco.png" alt="gennius" #img>
                <h1 class="text-gradient">for users</h1>
                <p class="target13">Miles offers users the freedom to split payments to <br> combine crypto, rewards programs, debit/credit cards, <br> and even pay in installments.</p>
            </div>
        </section>
        <section id="item-21-section" class="section parallax11">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target11">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <h4 id="item-21" class="target14">Everyday <br> spend</h4>
                                <p>Users redeem rewards <br>points locally or globally with <br>no restriction or expiration date.</p>
                                <p>100+ million stores <br> worldwide to redeem at.</p>
                                <p>Instant redemptions online <br> or via contactless in-store</p>
                                <p>Online payments via <br> e-wallets</p>
                            </div>
                        </div>
                    </div>
                    <img class="gennius__img gennius__img--loyalty" src="./assets/img/gennius/person.webp" alt="gennius">
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>
        </section>
        <section id="item-22-section" class="section parallax12">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target12">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <h4 id="item-22" class="target15">Millions <br> of travel <br> options</h4>
                                <p>Users get unlimited <br> access to the <strong>connected <br> world</strong> of banks, airlines, <br> hotels and merchants <br> everywhere while <br> enjoying millions of travel <br> options.</p>
                            </div>
                        </div>
                    </div>
                    <img class="gennius__img gennius__img--loyalty" src="./assets/img/gennius/person2.webp" alt="gennius">
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>
        </section>
        <section id="item-23-section" class="section parallax13">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target13">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <h4 id="item-23" class="target16">Unparalleled <br> travel <br> protection</h4>
                                <p>Users don't need to reach <br> their pockets again, <br> thanks to the <strong>travel <br> benefits</strong> and instant <br> compensation embedded <br> in our solutions.</p>
                            </div>
                        </div>
                    </div>
                    <img class="gennius__img gennius__img--loyalty" src="./assets/img/gennius/person3.webp" alt="gennius">
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>
        </section>
        <section id="item-24-section" class="section parallax14">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target14">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <h4 class="target17">Earn more <br> rewards</h4>
                                <p>Users earn up to <strong>5X more <br>rewards</strong> without limits, restrictions <br>or expiration dates.</p>
                                <p>Users can redeem miles for <br>over <strong>250 cryptocurrencies</strong> <br>across the blockchain, or redeem <br>crypto coins for miles.</p>
                            </div>
                            <div id="item-24" class="gennius__right gennius__right--loyalty">
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video autoplay="" id="item-24-video" loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>
        </section>
        <section id="item-25-section" class="section parallax15">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target15">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <span class="text-gradient">Best-in-class <br> customer service</span>
                                <h4 class="target18">Miles <br> management</h4>
                                <p><strong>No miles expiration</strong>, no <br> minimum miles required <br> to redeem, buy miles or <br> split payments anytime.</p>
                            </div>
                            <div id="item-25" class="gennius__right gennius__right--loyalty">
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video autoplay="" id="item-25-video" loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>
        </section>
        <section id="item-26-section" class="section parallax16">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target16">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <span class="text-gradient">Best-in-class <br> customer service</span>
                                <h4 class="target19">Conversational <br> banking</h4>
                                <p>Users can chat in app or <br> web or via their favorite <br> channles: WhatsApp, <br> iMessage, Facebook <br> Messenger or Instagram.</p>
                            </div>
                            <div id="item-26" class="gennius__right gennius__right--loyalty">
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video autoplay="" id="item-26-video" loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>

        </section>
        <section id="item-27-section" class="section parallax17">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target17">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <span class="text-gradient">Flexible ways to pay</span>
                                <h4 class="target20">Split <br> payments</h4>
                                <p><strong>Cardholders can combine <br> all favorite cards upon <br> checkout</strong>, dragging and <br> dropping them to split <br> their payment as they <br> wish, all from their e-wallet.</p>
                            </div>
                            <div id="item-27" class="gennius__right gennius__right--loyalty">
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video autoplay="" id="item-27-video" loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>
        </section>
        <section id="item-28-section" class="section parallax18">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target18">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <span class="text-gradient">Flexible ways to pay</span>
                                <h4 class="target21">Pay and <br> get paid</h4>
                                <p>Gig economy workers <br> and small businesses can <br> enjoy the convenience <br> and speed of paying and <br> getting paid instantly and <br> managing their funds <br> from wherever they are.</p>
                            </div>
                            <div id="item-28" class="gennius__right gennius__right--loyalty">
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video autoplay="" id="item-28-video" loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>
        </section>
        <section id="item-29-section" class="section parallax19 section--last">
            <div class="bg-wrap">
                <div class="bg">
                    <div class="container gennius target19">
                        <div class="gennius__bloque">
                            <div class="gennius__left gennius__left--loyalty">
                                <span class="text-gradient">Flexible ways to pay</span>
                                <h4 class="target22">Buy now, <br> pay later</h4>
                                <p>Users can combine <br> rewards with their <br> favorite cards and even <br> spread the payment out <br> over time.</p>
                            </div>
                            <div id="item-29" class="gennius__right gennius__right--loyalty">
                                <div [class]="videoClass" class="phone video-visible" *ngIf="itsMobile">
                                    <div class="content">
                                        <video autoplay="" id="item-29-video" loop muted playsinline onloadedmetadata="this.muted = true">
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-fixed"></div>
                    <app-connect></app-connect>
                </div>
            </div>
        </section>
    </section>
    <section class="scrolling">
        <section id="item-30-section" class="gennius--platform">
            <div class="container gennius">
                <h1 id="item-30">Our core platform</h1>
                <h1 class="text-gradient">advantages</h1>
                <div class="gennius__bloque gennius__bloque--platform">
                    <div class="gennius__left gennius__left--platform">
                        <span>Lifecycle Management</span>
                        <p class="text-gradient">End-to-End marketing support across channels and segments.</p>
                        <p>We use <strong>artificial intelligence</strong> to maximize end-to-end digital user journeys that drive insights and personalization to maximize results.
                        </p>
                        <p>Platform captures and learns form all user interactions, optimizing the experience by predicting behaviour.</p>
                    </div>
                    <div class="gennius__right gennius__right--platform">
                        <span>Digital<br> Engagement<br> Plan</span>
                        <p class="text-gradient">Our user journeys encompass cardholder onboarding, registration, first redemption, and repeated use.</p>
                        <p>Leading all marketing efforts through the development and execution of a <strong>turnkey solution</strong> to drive the issuer’s portfolio lifecycle.
                        </p>
                        <p>Ranges from free subscription to fully customized experience for banks, airlines, insurance companies and merchants.</p>
                    </div>
                </div>
                <div class="gennius__bloque gennius__bloque--fast">
                    <div class="gennius__left">
                        <img class="gennius__img gennius__img--fast" src="./assets/img/gennius/image-fast.webp" alt="gennius">

                    </div>
                    <div class="gennius__right gennius__right--fast">
                        <span>Fast-track<br> back office </span>
                        <p class="text-gradient2">Effortless implementation extends to a issuer’s daily logistics of managing cardholders’ accounts.</p>

                        <p><strong>Users' rewards points</strong>, point balances and updates are seamlessly managed through the platform’s back office. No technology or infrastructure development is required from the issuer.</p>
                    </div>
                </div>
                <div class="gennius__bloque gennius__bloque--banking">
                    <div class="gennius__left gennius__left--banking">

                        <span>Conversational <br> banking</span>
                        <p class="text-gradient2">alle, our AI-enabled chatbot and our <br> dedicated customer service team, relieve <br> clients from hiring customer service resources.</p>

                        <p>alle provides <strong>24/7</strong> support from the app, <br> via iMessage, Facebook Messenger or <br> WhatsApp, and can also instantly connect <br> users to human reps when needed.</p>
                    </div>
                    <div class="gennius__right gennius__right--banking">
                        <img class="gennius__img gennius__img--banking" src="./assets/img/gennius/image-banking.webp" alt="gennius">
                    </div>
                </div>
                <div class="gennius__bloque gennius__bloque--business">
                    <div class="gennius__left gennius__left--business">
                        <img class="gennius__img gennius__img--business" src="./assets/img/gennius/image-business.webp" alt="gennius">

                    </div>
                    <div class="gennius__right gennius__right--business">
                        <span>Transforming <br> traditional <br> business models </span>

                        <p><strong>Turnkey!</strong> Brand agnostic! Starting from a <br> free subscription to a fully customized <br> experience for banks, airlines and <br> merchants.</p>
                    </div>
                </div>
                <div class="gennius__bloque gennius__bloque--security">
                    <div class="header">
                        <span>Top-notch security <br> and privacy standards</span>
                        <p class="light-blue">Top-notch technology that serves your <br> customers’ safety and security.</p>
                    </div>
                    <div class="gennius__left gennius__left--security">
                        <p class="light-blue">Data Privacy </p>
                        <p><strong>Integration with business platforms with high <br> standards of innovation.</strong> Our Information <br> Security Policy (ISP) complies with <br> international industry standards, including <br> ISO, PCI DSS, and GDPR where applicable.</p>
                        <p class="light-blue">Platform security </p>
                        <p><strong>Sensitive payment</strong> data protected meeting <br> all industry standards. Our partnership with <br> CyberSource (a Visa Inc. company) <br> guarantees a Level 1 PCI Service Provider <br> certification.</p>
                    </div>
                    <div class="gennius__right gennius__right--security">
                        <img class="gennius__img gennius__img--security" src="./assets/img/gennius/image-security.webp" alt="gennius">
                    </div>
                </div>
            </div>
        </section>
        <section id="item-31-section" class="gennius--proud gennius--container gennius--key">
            <div class="container gennius">
                <h3 id="item-31">Key challenges and<br> benefits for businesses</h3>

                <p>Issuers plugged into our platform not only access state-of-the-art technology, but also bring in an <strong>end-to-end digital engagement and lifecycle management solutions</strong> coped with added-value support from dedicated technology, customer service, marketing and IT teams.</p>

                <div class="gennius__bloque gennius__bloque--top">
                    <div class="gennius__column gennius__column--key">
                        <span>Transforms<br> traditional<br> business models</span>
                    </div>
                    <div class="gennius__column gennius__column--key">
                        <span>A turnkey,<br> brand agnostic<br> solution</span>
                    </div>
                    <div class="gennius__column gennius__column--key">
                        <span>Starting from free subscription to fully-customized experience for banks, airlines and
                            merchants</span>
                    </div>
                </div>
            </div>
        </section>
        <section id="item-32-section" class="gennius-challenges">
            <div class="container challenges">
                <h3 id="item-32">Challenges of managing a Rewards Programs</h3>

                <div class="challenges__block">
                    <div class="challenges__row challenges__row--tab">
                        <div class="challenges__item">
                            <img class="challenges__icono" src="./assets/img/gennius/icon-digital.png" alt="gennius">
                            <span>Digital <br>Transformation</span>
                        </div>
                        <div class="challenges__item">
                            <img class="challenges__icono" src="./assets/img/gennius/icon-control.png" alt="gennius">
                            <span>Control<br>Burn Rate</span>
                        </div>
                        <div class="challenges__item">
                            <img class="challenges__icono" src="./assets/img/gennius/icon-cost.png" alt="gennius">
                            <span>Cost</span>
                        </div>
                        <div class="challenges__item">
                            <img class="challenges__icono" src="./assets/img/gennius/icon-ongoing.png" alt="gennius">
                            <span>Ongoing<br>Operation</span>
                        </div>
                        <div class="challenges__item">
                            <img class="challenges__icono" src="./assets/img/gennius/icon-perceived.png" alt="gennius">
                            <span>Perceived<br>Value</span>
                        </div>
                    </div>
                    <div class="challenges__row challenges__row--challen">
                        <div class="challenges__item challenges__item--challen-tittle">
                            <span>Challenges</span>
                        </div>
                        <div class="challenges__item challenges__item--challen">
                            <ul>
                                <li>
                                    <span class="icon-bullet"></span>
                                    <p>Not core to<br> the bank</p>
                                </li>
                                <li>
                                    <span class="icon-bullet"></span>
                                    <p>IT resources<br> constrained</p>
                                </li>
                                <li>
                                    <span class="icon-bullet"></span>
                                    <p>Lengthy<br> implementation<br> times</p>
                                </li>
                            </ul>
                        </div>
                        <div class="challenges__item challenges__item--challen">
                            <ul>
                                <li>
                                    <span class="icon-bullet"></span>
                                    <p>Cashflow /<br> Liability<br> equilibrium</p>
                                </li>
                            </ul>
                        </div>
                        <div class="challenges__item challenges__item--challen">
                            <ul>
                                <li>
                                    <span class="icon-bullet"></span>
                                    <p>High platform<br> & maintenance<br> cost
                                    </p>
                                </li>
                                <li>
                                    <span class="icon-bullet"></span>
                                    <p>Program ROI
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <div class="challenges__item challenges__item--challen">
                            <ul>
                                <li>
                                    <span class="icon-bullet"></span>
                                    <p>Dedicated resourses & prioritization
                                    </p>
                                </li>
                                <li>
                                    <span class="icon-bullet"></span>
                                    <p>Continual communication & education</p>
                                </li>
                            </ul>
                        </div>
                        <div class="challenges__item challenges__item--challen">
                            <ul>
                                <li>
                                    <span class="icon-bullet"></span>
                                    <p>Points liquidity</p>
                                </li>
                                <li>
                                    <span class="icon-bullet"></span>
                                    <p>Redemption options</p>
                                </li>
                                <li>
                                    <span class="icon-bullet"></span>
                                    <p>Seamless experience</p>
                                </li>
                                <li>
                                    <span class="icon-bullet"></span>
                                    <p>Relevance</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="challenges__row challenges__row--miles">
                        <div class="challenges__item challenges__item--miles challenges__item--miles-tittle">
                            <img class="challenges__icono challenges__icono--miles" src="./assets/img/gennius/logo-miles.png"
                                alt="gennius">
                        </div>
                        <div class="challenges__item challenges__item--miles">
                            <img class="challenges__icono challenges__icono--miles" src="./assets/img/gennius/icon-approved.png"
                                alt="gennius">
                            <span>Complimentary turnkey, white-label solution to manage user rewards, from accrual to unlimited
                                redemption</span>
                        </div>
                        <div class="challenges__item challenges__item--miles">
                            <img class="challenges__icono challenges__icono--miles" src="./assets/img/gennius/icon-approved.png"
                                alt="gennius">
                            <span>Custom controls to manage cashflow and contributes to card spend</span>
                        </div>
                        <div class="challenges__item challenges__item--miles">
                            <img class="challenges__icono challenges__icono--miles" src="./assets/img/gennius/icon-approved.png"
                                alt="gennius">
                            <span>SaaS model and revenue sharing</span>
                        </div>
                        <div class="challenges__item challenges__item--miles">
                            <img class="challenges__icono challenges__icono--miles" src="./assets/img/gennius/icon-approved.png"
                                alt="gennius">
                            <span>In-built plattform support and lifecycle management</span>
                        </div>
                        <div class="challenges__item challenges__item--miles">
                            <img class="challenges__icono challenges__icono--miles" src="./assets/img/gennius/icon-approved.png"
                                alt="gennius">
                            <span>Millions of redemptions options and unique ways to redeem plus additional benefits</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <app-footer></app-footer>
        <section class="section clearBoth"></section>
    </section>
</section>
